import { findRecursive } from '@/mm/utils.js'

export function washData_relatedCarouselNews(walkedNode) {
  if (walkedNode._type === 'related_carousel_news1') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    const buttonNode = findRecursive(
      walkedNode.list,
      (item) => item._type === 'button_text_1',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode) {
      if (!buttonNode.actions.find((item) => item === 'translate')) {
        buttonNode.actions.push('translate')
      }
    }
  } else if (walkedNode._type === 'related_carousel_news2') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    const buttonNode = findRecursive(
      walkedNode.list,
      (item) => item._type === 'button_text_1',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode && !buttonNode.actions.find((item) => item === 'translate')) {
      buttonNode.actions.push('translate')
    }
  } else if (walkedNode._type === 'related_carousel_news3') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
  } else if (walkedNode._type === 'related_carousel_news4') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    const buttonNode = findRecursive(
      walkedNode.list,
      (item) => item._type === 'button_text_1',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode && !buttonNode.actions.find((item) => item === 'translate')) {
      buttonNode.actions.push('translate')
    }
  }
}
